<template>
  <div>
    <div class="white box pa-6">
       <!-- Radio buttons para tipo de gastos -->
      <v-row class="pt-6 mx-2">
        <v-col cols="12">
          <v-radio-group v-model="expenseType" @change="onExpenseTypeChange" row>
            <v-radio label="Gastos" value="gastos"></v-radio>
            <v-radio label="Gastos DCL" value="gastos_dcl"></v-radio>
            <v-radio label="Comprobante retención" value="comprobante_retencion"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col cols="12" sm="6" md="3" lg="3">
          <v-select
            v-model="selectedBranch"
            :items="branches"
            item-text="BranchName"
            item-value="ID_Branch"
            label="Sucursal"
            :hint="currentBranch ? `Sucursal actual: ${currentBranch}` : ''"
            persistent-hint
            dense
            outlined
          />
        </v-col>
        <v-col cols="12" sm="12" md="9" lg="9" class="d-flex" style="justify-content: space-between;">
          <v-checkbox v-model="enableDates" @change="(e) => enableDates = e" label="Filtrar Fecha" class="mx-5 pt-1"></v-checkbox>
          <date-picker :disbaled="!enableDates"  label="Fecha inicio" @dateSelected="(param) => startDate = param" class="mx-5" />
          <date-picker :disbaled="!enableDates" label="Fecha fin" @dateSelected="(param) => endDate = param" class="mx-5" />
          <v-btn @click="filterDateHandler();" color="primary" :disabled="!enableDates">
            <v-icon class="mr-1">mdi-filter</v-icon>
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
      <!-- Table -->
        <div>
          <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2"></v-progress-linear>
          <GeneralFilter
            :filterEndpoint="currentFilterEndpoint"
            :search="searchWithDates"
            @emptyFilter="currentEmptyFilterMethod"
            @filtered="filterHandlerEntry"
            v-if="$store.getters['rolesUser/getCustomRole'](218)"
          >
            <template v-if="expenseType === 'gastos'"> 
              <v-alert
                type="info"
                border="left"
                colored-border
                elevation="2"
                class="mb-4"
              >
                <div class="d-flex align-center flex-wrap">
                  <div class="accounting-alert-title flex-grow-1">
                    <strong>Importante:</strong>
                    El control de partidas generadas por ingresos masivos y partidas automáticas comenzó a aplicarse a partir del
                    <strong>1 de julio de 2026</strong>.
                  </div>

                  <v-btn
                    text
                    small
                    color="info"
                    class="mt-2 mt-sm-0 ml-sm-2 align-self-start"
                    @click="showAccountingAlertDetails = !showAccountingAlertDetails"
                  >
                    {{ showAccountingAlertDetails ? 'Ver menos' : 'Ver más' }}

                    <v-icon right small>
                      {{ showAccountingAlertDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </v-btn>
                </div>

                <v-expand-transition>
                  <div
                    v-if="showAccountingAlertDetails"
                    class="mt-3"
                  >
                    Por esta razón, en los meses anteriores a esa fecha es posible que el botón
                    <strong>Crear partida</strong> aparezca habilitado.

                    Esto no significa que la compra o el gasto no tenga una partida registrada,
                    sino que esos registros fueron realizados antes de que iniciara este control
                    y, por lo tanto, no se reflejan bajo la nueva validación.
                  </div>
                </v-expand-transition>
              </v-alert>
            </template>
            <DxDataGrid
              :data-source="entries"
              :show-row-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :scrolling="{ useNative: true }"    
              :column-auto-width="true"
              @exporting="onExporting"
            >
              <DxExport :enabled="true" />
              <DxPaging :page-size="10" />
              <DxColumn
                :width="92"
                caption="Acciones"
                cell-template="showdata"
                v-if="$store.getters['rolesUser/getCustomRole'](219)"
              />
              <!-- Columnas para Gastos y Gastos DCL -->
              <template v-if="expenseType !== 'comprobante_retencion'">
                <!-- <DxColumn :width="columnWidth" caption="ID" data-field="ID"></DxColumn> -->
                <DxColumn :width="90" caption="ID" data-field="ID"></DxColumn>
                <DxColumn :width="150" caption="Sucursal" data-field="BranchName"></DxColumn>
                <DxColumn :width="150" caption="Fecha" data-field="ExpenseInvoiceDate"></DxColumn>
                <DxColumn :width="120" caption="ID proveedor" data-field="ID_Provider"></DxColumn>
                <DxColumn :width="250" caption="Nombre proveedor" data-field="ProviderName"></DxColumn>
                <DxColumn :width="150" caption="SubTotal" data-field="SubTotal" :calculate-display-value="v => formatNc(v, 'SubTotal')"></DxColumn>
                <DxColumn :width="150" caption="Total" data-field="TotalExpense" :calculate-display-value="v => formatNc(v, 'TotalExpense')"></DxColumn>
                <DxColumn :width="280" caption="Numero de comprobante" data-field="ExpenseInvoiceId"></DxColumn>
              </template>
              <!-- Columnas para Comprobante de Retención -->
              <template v-else>
                <DxColumn :width="100" caption="Fecha" data-field="IdentificacionFecEmi"></DxColumn>
                <DxColumn :width="120" caption="NIT Emisor" data-field="EmisorNit"></DxColumn>
                <DxColumn :width="120" caption="ID" data-field="ID_Customer"></DxColumn>
                <DxColumn :width="250" caption="Nombre cliente" data-field="LegalName"></DxColumn>
                <DxColumn :width="150" caption="Total sujeto" data-field="ResumenTotalSujetoRetencion" :calculate-display-value="v => formatCurrency(v, 'ResumenTotalSujetoRetencion')"></DxColumn>
                <DxColumn :width="150" caption="Total IVA retenido" data-field="ResumenTotalIvaRetenido" :calculate-display-value="v => formatCurrency(v, 'ResumenTotalIvaRetenido')"></DxColumn>
                <DxColumn :width="250" caption="Numero de comprobante" data-field="IdentificacionNumeroControl"></DxColumn>
                <DxColumn :width="280" caption="Cód. Generación" data-field="IdentificacionCodigoGeneracion"></DxColumn>
              </template>
              <DxColumn :width="80" cell-template="delete" v-if="$store.getters['rolesUser/getCustomRole'](219)"/>
              <template #showdata="{ data }">
                <div class="history-action-cell">
                  <a href="#" class="history-action-link" title="Ver mas" @click.prevent.stop="handleEntry(data.data)">
                    <v-icon small color="primary">mdi-eye</v-icon>
                  </a>
                  <v-btn
                    v-if="expenseType === 'gastos'"
                    icon
                    x-small
                    class="history-action-button"
                    :title="getAccountingEntryActionTitle(data.data)"
                    :disabled="isAccountingEntryActionLoading(data.data) || !hasKnownAccountingEntryState(data.data)"
                    @click.prevent.stop="handleAccountingEntryAction(data.data)"
                  >
                    <v-progress-circular
                      v-if="isAccountingEntryActionLoading(data.data)"
                      indeterminate
                      size="15"
                      width="2"
                      color="primary"
                    ></v-progress-circular>
                    <v-icon v-else small :color="data.data.id_accounting_entry ? 'primary' : hasKnownAccountingEntryState(data.data) ? 'success' : 'grey'">
                      {{ data.data.id_accounting_entry ? 'mdi-file-eye-outline' : hasKnownAccountingEntryState(data.data) ? 'mdi-file-plus' : 'mdi-alert-circle-outline' }}
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <template #delete="{ data }">
                <a href="#" @click.prevent.stop="expenseType === 'comprobante_retencion' ? confirmDeleteWithholding(data.data) : confirmDeleteEntry(data.data)">
                  <v-icon color="error">mdi-delete</v-icon>
                </a>
              </template>
            </DxDataGrid>
          </GeneralFilter>
        </div>
     
      <!-- Table -->

      <!-- Dialog -->
      <v-dialog v-model="showForm" width="80%" max-height="85vh">
        <v-card v-if="entry" class="white box pa-6" style="max-height: 85vh; overflow-y: auto;">
          <v-row class="bg-dark text-h6 pa-3 rounded-lg mb-2">
            <v-col cols="12" md="4" align="left">
              <span class="font-weight-bold">ID Factura: </span>{{ entry.ID }}
            </v-col>
            <v-col cols="12" md="4" align="center">
              <span class="font-weight-bold">{{ expenseType !== 'comprobante_retencion' ? 'Proveedor: ' : 'Cliente: ' }}</span>
              {{ expenseType !== 'comprobante_retencion' ? entry.ProviderName : entry.LegalName }}
            </v-col>
            <v-col cols="12" md="4" align="right">
              <v-btn
                small
                v-if="$store.getters['rolesUser/getCustomRole'](219) && expenseType !== 'comprobante_retencion'"
                color="error"
                @click="confirmDeleteEntry(entry)"
              >
                <v-icon> mdi-delete </v-icon> 
              </v-btn>
              <v-btn
                small
                v-if="$store.getters['rolesUser/getCustomRole'](219) && expenseType === 'comprobante_retencion'"
                color="error"
                @click="confirmDeleteWithholding({ ID: entry.ID })"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="box navbar" style="min-width: 250px; justify-content: space-around; flex-wrap: wrap;">
            <!-- Campos para gastos regulares -->
            <template v-if="expenseType !== 'comprobante_retencion'">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">SUB TOTAL</span>
                </div>
                <input type="text" class="form-control" :value="parseFloat(entry.SubTotal).toFixed(2)" disabled>
              </div>
              <div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">IVA</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Iva).toFixed(2)" disabled>
                </div>
              </div>
              <div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">EXENTAS</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Exentas).toFixed(2)" disabled>
                </div>
              </div>
              <div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">NO SUJ.</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.NoSujetas).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.IvaRet > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="EXENTAS">IVA Ret.</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.IvaRet).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.IvaPerc > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" >IVA Per.</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.IvaPerc).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.ReteRenta > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" >Rete Renta</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.ReteRenta).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.Fovial > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Fovial</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Fovial).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.Cotrans > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Cotrans</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Cotrans).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.Flete > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Flete</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Flete).toFixed(2)" disabled>
                </div>
              </div>
              <div v-if="entry.Seguro > 0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Seguro</span>
                  </div>
                  <input type="text" class="form-control" :value="parseFloat(entry.Seguro).toFixed(2)" disabled>
                </div>
              </div>
              <div class="input-group ">
                <div class="input-group-prepend">
                  <span class="input-group-text">VENTA TOTAL</span>
                </div>
                <input type="text" class="form-control" :value="parseFloat(entry.TotalExpense).toFixed(2)" disabled>
              </div>
            </template>
            <!-- Totales para comprobante de retención -->
            <template v-else>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">TOTAL SUJETO RETENCIÓN</span>
                </div>
                <input type="text" class="form-control" :value="parseFloat(entry.ResumenTotalSujetoRetencion || 0).toFixed(2)" disabled>
              </div>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">TOTAL IVA RETENIDO</span>
                </div>
                <input type="text" class="form-control" :value="parseFloat(entry.ResumenTotalIvaRetenido || 0).toFixed(2)" disabled>
              </div>
            </template>

           
          </div>
          
          <br/><br/>
          <!-- Datos textuales del comprobante de retención -->
          <v-row v-if="expenseType === 'comprobante_retencion'" class="px-3 pb-2">
            <v-col cols="12" md="4">
              <p><b>Cód. Generación:</b> {{ entry.IdentificacionCodigoGeneracion || 'N/A' }}</p>
            </v-col>
            <v-col cols="12" md="4">
              <p><b>Núm. Control:</b> {{ entry.IdentificacionNumeroControl || 'N/A' }}</p>
            </v-col>
            <v-col cols="12" md="4">
              <p><b>NIT Emisor:</b> {{ entry.EmisorNit || 'N/A' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" v-if="entry.CatalogName">
              <p><b>CUENTA CONTABLE:</b> {{ entry.CatalogName }}</p>
            </v-col>
            
            <!-- Campos adicionales para DCL como detalle -->
            <template v-if="expenseType === 'gastos_dcl'">
              <v-col cols="12">
                <h3 class="tabs" style="text-align: center; margin-bottom: 20px;">
                  Información Detallada
                </h3>
              </v-col>
              
              <v-col cols="12" md="6">
                <p><b>Descripción Sin Percepción:</b> {{ entry.descripSinPercepcion || 'NO APLICA' }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>Código de Liquidación:</b> {{ entry.codLiquidacion || 'N/A' }}</p>
              </v-col>
              
              <v-col cols="12" md="6">
                <p><b>Período Liquidación - Inicio:</b> {{ entry.periodoLiquidacionFechaInicio || 'N/A' }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>Período Liquidación - Fin:</b> {{ entry.periodoLiquidacionFechaFin || 'N/A' }}</p>
              </v-col>
              
              <v-col cols="12" md="6">
                <p><b>Valor de Operaciones:</b> ${{ parseFloat(entry.valorOperaciones || 0).toFixed(2) }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>Cantidad de Documentos:</b> {{ entry.cantidadDoc || '0' }}</p>
              </v-col>
              
              <v-col cols="12">
                <p><b>Total en Letras:</b> {{ entry.totalLetras || 'N/A' }}</p>
              </v-col>
              
              <v-col cols="12">
                <p><b>Observaciones:</b> {{ entry.observaciones || 'NO APLICA' }}</p>
              </v-col>
            </template>
            
            </v-row>

          <!-- Clasificación para anexos y Período Personalizado -->
          <v-row v-if="expenseType !== 'comprobante_retencion'" class="mt-4 mb-4">
            <v-col cols="12">
              <v-card outlined class="pa-6">
                <v-row align="center" class="mb-2">
                  <v-col>
                    <h3>Clasificación para anexos</h3>
                  </v-col>
                  <v-col cols="auto">
                    <template v-if="!editingClassification">
                      <v-btn small color="secondary" @click="startEditClassification()">
                        <v-icon small class="mr-1">mdi-pencil</v-icon>
                        Editar
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn small color="primary" class="mr-2" @click="saveClassification()">
                        <v-icon small class="mr-1">mdi-content-save</v-icon>
                        Guardar
                      </v-btn>
                      <v-btn small color="grey" @click="cancelEditClassification()">
                        <v-icon small class="mr-1">mdi-close</v-icon>
                        Cancelar
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>

                <!-- Modo lectura -->
                <template v-if="!editingClassification">
                  <v-row>
                    <v-col cols="12" md="4">
                      <p class="mb-1"><b>Clasificación (Renta):</b> {{ getClasificationRentLabel(entry.ClasificationRent) }}</p>
                    </v-col>
                    <v-col cols="12" md="4">
                      <p class="mb-1"><b>Sector:</b> {{ getSectorLabel(entry.SectorProveedores) }}</p>
                    </v-col>
                    <v-col cols="12" md="4">
                      <p class="mb-1"><b>Tipo de Costo / Gasto:</b> {{ getTipoIngresoLabel(entry.TipoIngresoProveedores) }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <p class="mb-1"><b>Período Personalizado Para CSV's:</b> {{ entry.CustomCSVPeriodFlag ? 'Sí' : 'No' }}</p>
                    </v-col>
                    <template v-if="entry.CustomCSVPeriodFlag">
                      <v-col cols="12" md="4">
                        <p class="mb-1"><b>Mes:</b> {{ getMonthName(entry.CustomCSVPeriodMonth) }}</p>
                      </v-col>
                      <v-col cols="12" md="4">
                        <p class="mb-1"><b>Año:</b> {{ entry.CustomCSVPeriodYear }}</p>
                      </v-col>
                    </template>
                  </v-row>
                </template>

                <!-- Modo edición -->
                <template v-else>
                  <v-row>
                    <v-col cols="12" md="4">
                      <ClasificationRentaAutocomplete v-model="editClassificationData.ClasificationRent" />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select outlined dense v-model="editClassificationData.SectorProveedores" :items="sectorProveedoresList" item-text="Valores" item-value="Codigo" label="Sector" attach clearable></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select outlined dense v-model="editClassificationData.TipoIngresoProveedores" :items="tipoIngresoProveedoresList" item-text="Valores" item-value="Codigo" label="Tipo de Costo / Gasto" attach clearable></v-select>
                    </v-col>
                    <v-col cols="12">
                      <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                    </v-col>
                  </v-row>
                  <!-- Período Personalizado Para CSV's -->
                  <v-row class="mt-3">
                    <v-col cols="12" md="4">
                      <v-checkbox hide-details v-model="editClassificationData.CustomCSVPeriodFlag" label="Período Personalizado Para CSV's" :true-value="1" :false-value="0"></v-checkbox>
                    </v-col>
                    <template v-if="editClassificationData.CustomCSVPeriodFlag">
                      <v-col cols="12" md="4">
                        <v-select outlined dense v-model="editClassificationData.CustomCSVPeriodMonth" :items="monthList" item-text="text" item-value="value" label="Mes" attach></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field outlined dense v-model="editClassificationData.CustomCSVPeriodYear" label="Año" type="number" attach></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </template>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="expenseType !== 'comprobante_retencion'">
            <template>
              <v-col cols="12" md="6">
                <h3 :class="showBgcolorNotes" style="text-align: center" @click="showComments = !showComments">
                  Notas internas de la factura
                </h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="tabs" style="text-align: center" @click="showInfoInvoice = !showInfoInvoice">
                  Datos de la factura del proveedor
                </h3>
              </v-col>
            </template>
          </v-row>

          <v-row v-if="expenseType !== 'comprobante_retencion'">
          <!--GeneralFilter
              :filterEndpoint="
                $API.accountingexpensesentrydetail.filteredAccountingExpensesEntryDetails
              "
              :search="search"
              @emptyFilter="getAllEntriesDetails"
              @filtered="filterHandlerDetails"
            -->
              <DxDataGrid
                :data-source="entryDetails"
                :show-row-lines="true"
                :show-borders="true"
                :row-alternation-enabled="true"
                :scrolling="{ mode: 'standard', useNative: true, showScrollbar: 'always' }"
                height="45vh"
                :column-auto-width="true"
              >
              
                <DxPaging :page-size="10" />
                <!--DxColumn :width="columnWidth"  caption="ID Detalle" data-field="ID_Admin_Expenses"></DxColumn-->
                <!--DxColumn :width="columnWidth"
                  caption="Cuenta contable"
                  data-field="CatalogName"
                ></DxColumn-->
                <DxColumn
                  :allow-editing="false"
                  cell-template="accounting-code"
                  caption="Cuenta Contable"
                ></DxColumn>
                <template #accounting-code="{ data }">
                  <a href="#" @click="addAccountingCodeByItem(data.data)">
                    <v-icon>mdi-pencil</v-icon>
                    <span v-if="data.data?.message">{{ data.data.message }}</span>
                  </a>
                </template>
                <DxColumn :width="columnWidth" caption="Cuenta Contable" data-field="CatalogName"></DxColumn>
                <DxColumn :width="columnWidth" caption="Nombre" data-field="NameExpense"></DxColumn>
                <DxColumn :width="columnWidth" caption="Cantidad" data-field="Quantity"></DxColumn>
                <DxColumn :width="columnWidth" caption="Precio Unidad" data-field="UnitPrice"></DxColumn>
                <DxColumn :width="columnWidth" caption="Total" data-field="Total"></DxColumn>
                <DxColumn :width="100" caption="Exento" cell-template="IsExento"></DxColumn>
                <template #IsExento="{ data }">
                  <input type="checkbox" v-model="data.data.IsExento" disabled/>
                </template>
                <DxColumn :width="100" caption="No Sujeto" cell-template="IsNoSujeto"></DxColumn>
                <template #IsNoSujeto="{ data }">
                  <input type="checkbox" v-model="data.data.IsNoSujeto" disabled/>
                </template>
              </DxDataGrid>
            <!--/GeneralFilter-->
          </v-row>
        </v-card>
      </v-dialog>
      <!-- Dialog -->
      <v-dialog
        v-model="showAccountingEntryAdvanced"
        width="95%"
        max-width="1600"
        content-class="accounting-entry-dialog"
        scrollable
        persistent
      >
        <ExpenseManagmentMassiveEntryAdvanced
          v-if="showAccountingEntryAdvanced"
          :win="win"
          :entry-only-mode="true"
          :stored-expense="selectedExpenseForAccounting"
          :stored-expense-details="selectedExpenseDetails"
          @created="handleAccountingEntryCreated"
          @cancel="closeAccountingEntryAdvanced"
          @close="closeAccountingEntryAdvanced"
        />
      </v-dialog>

      <v-dialog v-model="showInfoInvoice" width="60%" style="z-index: 150;">
        <v-card v-if="entry" class="border">
          <v-btn @click="showInfoInvoice = false" elevation="0" color="red" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-title class="text-h5">Datos de la factura</v-card-title>
          <v-card-text>
            <v-row class="mt-6 ml-2 mr-2 mb-6">
              <v-col cols="12" md="3">
                <center>
                  <v-img :src="entry.ExpenseInvoiceImage" width="100px" height="100px" class="preview-avatar"></v-img>
                </center>
                <br/>
                <center>
                  <a :href="entry.ExpenseInvoiceImage" style="vertical-align: bottom; border-radius: 5px;" class="btn btn-save pa-3" target="_blank" rel="noopener" v-if="entry.ExpenseInvoiceImage">Ver documento</a>
                  <p v-else>Compra sin documento de facturación.</p>
                </center>
                <br/>
              </v-col>

              <v-col cols="12" md="9">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field outlined dense label="Fecha de la Factura" v-model="entry.ExpenseInvoiceDate" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select outlined dense :items="catalogTypedocument" attach label="Tipo de Factura" v-model="entry.ExpenseInvoiceType" required
                    disabled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-model="entry.ExpenseInvoiceDocumentType"
                      :items="documentOptions" :items-value="value" :items-text="text" attach
                      label="Tipo de documento" required disabled></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined dense v-model="entry.ExpenseInvoiceId" required 
                      :label="entry.ExpenseInvoiceDocumentType == '2' ? 'Código de generación' : 'Correlativo de factura'" disabled></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-model="entry.ExpenseInvoicePayment"
                      :items="paymentMethod" attach label="Método de Pago" required disabled></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-model="entry.ExpenseInvoiceStatus" :items="invoiceStatus"
                      label="Estado de la Factura" attach required disabled></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-if="entry.ExpenseInvoiceStatus == 'Crédito'"
                      v-model="entry.ExpenseInvoiceCreditDays" :items="days" label="Plazo" attach disabled></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        
      </v-dialog>
      <v-dialog v-model="showAccountingForm" scrollable width="70%" style="z-index: 160;">
          <ExpenseDialog
          :win="win"
          :newAccountList="accountList"
          :newSelectedExpense="selectedExpense"
          :action="action"
          @handleAction="handleAction"
          />
        </v-dialog>
      <!-- Dialog -->
      <v-dialog v-model="showComments" width="60%">
        <v-card v-if="entry" class="border">
          <v-btn @click="showComments = false" elevation="0" color="red" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title class="text-h5">Notas internas de la factura</v-card-title>
          <v-card-text>
            <quill-editor
            :content="entry.ExpenseInvoiceComment"
            @change="onEditorChange($event)"
            ></quill-editor>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-right">
              <v-btn @click="showComments = !showComments" class="btndisable">
                Continuar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Alert -->
    <alert
      v-model="alert.show"
      @action="alert.action"
      :type="alert.type"
      :title="alert.title"
    >
      {{ alert.message }}
    </alert>
    <!-- Alert -->
  </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport, DxPaging } from "devextreme-vue/data-grid";
import GeneralFilter from "@/components/GeneralFilter.vue";
import DatePicker from "../../../components/DatePicker";
import { printToExcel } from "@/helpers/printToexcel";
import ExpenseDialog from "../ExpenseDialog.vue";
import ClasificationRentaAutocomplete from "../../../components/Misc/ClasificationRentaAutocomplete.vue";
import ExpenseManagmentMassiveEntryAdvanced from "./ExpenseManagmentMassiveEntryAdvanced.vue";
import { mapGetters } from "vuex";

export default {
  name: "ExpenseManagmentEntryHistory",

  components: {
    DxDataGrid,
    DxColumn,
    DxExport,
    DxPaging,
    GeneralFilter,
    DatePicker,
    ExpenseDialog,
    ExpenseManagmentMassiveEntryAdvanced,
    ClasificationRentaAutocomplete
  },

  props: ["win"],

  data() {
    return {
      expenseType: 'gastos', // Valor por defecto
      entries: null,
      entry: null,
      entryDetails: null,
      alert: {
        show: false,
        type: "info",
        title: "",
        message: "",
        action: (() => null),
      },  
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showForm: false,
      search: {
        filter: null,
        ID_Branch: null,
      },
      selectedBranch: null,
      branches: [],
      currentBranch: null,
      suppressBranchWatcher: false,
      entryID: null,
      showBgcolorNotes: "tabs",
      showComments: false,
      showInfoInvoice: false,
      catalogTypedocument: [],
      documentOptions: [
        { value: "1", text: "Físico" },
        { value: "2", text: "Electrónico" },
      ],
      paymentMethod: [
        "Efectivo",
        "Cheque",
        "Transferencia",
        "Tarjeta de Crédito",
        "Otro",
      ],
      invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito", "Anulada"],
      days: ['8 Dias', '15 Dias', '30 Dias', '90 Dias', '120 Dias', '180 Dias'],
      deleteData: null,
      loading: false,
      enableDates: false,
      startDate: null,
      endDate: null,
      searchTimeout: null,
      accountList: {},
      showAccountingForm: false,
      accountingEntryActionLoading: {},
      showAccountingEntryAdvanced: false,
      selectedExpenseForAccounting: null,
      selectedExpenseDetails: [],
      action: {
        ADD: false,
        EDIT: false,
        DEL: false,
        ADD_ONE: false,
      },
      selectedExpense: {
        ExpenseName: null,
        ID: null,
        CatalogName: null,
      },
      editingClassification: false,
      editClassificationData: {},
      monthList: [
        { text: 'Enero', value: 1 },
        { text: 'Febrero', value: 2 },
        { text: 'Marzo', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Mayo', value: 5 },
        { text: 'Junio', value: 6 },
        { text: 'Julio', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Septiembre', value: 9 },
        { text: 'Octubre', value: 10 },
        { text: 'Noviembre', value: 11 },
        { text: 'Diciembre', value: 12 },
      ],
      showAccountingAlertDetails: false,
    };
  },

  mounted() {
    this.getCatalogTypedocument();
    this.getAllAcounts();
    this.getBranches();
  },

  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },

  watch: {
    enableDates: {
      deep: true,
      immediate: true,
      handler(val) {
        //console.log(val);
        if(val == false) {
          this.reloadEntries();
        }
      }
    },
    selectedBranch() {
      if (this.suppressBranchWatcher) {
        return;
      }
      this.onBranchChange();
    },
    startDate() {
      // Si las fechas están habilitadas y hay texto en el buscador, actualizar automáticamente
      if (this.enableDates && this.endDate && this.search.filter && this.search.filter.trim() !== '') {
        // Pequeño delay para evitar múltiples llamadas
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          // Simular el evento de búsqueda del GeneralFilter
          const searchParams = { ...this.searchWithDates };
          this.currentFilterEndpoint(searchParams).then((response) => {
            this.filterHandlerEntry(response);
          });
        }, 300);
      }
    },
    endDate() {
      // Si las fechas están habilitadas y hay texto en el buscador, actualizar automáticamente
      if (this.enableDates && this.startDate && this.search.filter && this.search.filter.trim() !== '') {
        // Pequeño delay para evitar múltiples llamadas
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          // Simular el evento de búsqueda del GeneralFilter
          const searchParams = { ...this.searchWithDates };
          this.currentFilterEndpoint(searchParams).then((response) => {
            this.filterHandlerEntry(response);
          });
        }, 300);
      }
    }
  },

  methods: {
    getCurrentBranchId() {
      const branchFromStorage = JSON.parse(localStorage.getItem("branch"))?.ID_Branch;
      const userBranch = JSON.parse(localStorage.getItem("user"))?.branch;
      return branchFromStorage || userBranch || null;
    },
    getBranchNameById(branchId) {
      if (branchId === null || branchId === undefined || branchId === '') {
        return '';
      }

      if (String(branchId) === 'all') {
        return 'Todas las sucursales';
      }

      const branch = this.branches.find(item => String(item.ID_Branch) === String(branchId));
      return branch ? branch.BranchName : '';
    },
    normalizeEntriesWithBranchName(data) {
      const rows = Array.isArray(data) ? data : [];
      return rows.map((row) => ({
        ...row,
        BranchName: row.BranchName || this.getBranchNameById(row.ID_Branch) || row.BranchName || '',
      }));
    },
    async reloadEntries() {
      if (this.selectedBranch === null || this.selectedBranch === undefined || this.selectedBranch === '') {
        return;
      }

      if (this.search.filter && this.search.filter.trim() !== '') {
        try {
          this.loading = true;
          const searchParams = { ...this.searchWithDates };
          const response = await this.currentFilterEndpoint(searchParams);
          this.filterHandlerEntry(response);
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.showAlert("warning", "Error", "Ha ocurrido un error al recargar los registros.");
        }
        return;
      }

      if (this.enableDates && this.startDate && this.endDate) {
        this.filterDateHandler();
        return;
      }

      if (this.expenseType === 'gastos_dcl') {
        this.getAllEntriesDCL();
      } else if (this.expenseType === 'comprobante_retencion') {
        this.getAllEntriesWithholdingCertificates();
      } else {
        this.getAllEntries();
      }
    },
    getBranches() {
      this.$API.branches
        .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
        .then((data) => {
          const allOption = { ID_Branch: 'all', BranchName: 'Todas las sucursales' };
          this.branches = [allOption, ...data];

          this.suppressBranchWatcher = true;
          this.selectedBranch = this.getCurrentBranchId();
          const currentBranchData = data.find(branch => branch.ID_Branch == this.selectedBranch);
          this.currentBranch = currentBranchData ? currentBranchData.BranchName : null;
          this.search.ID_Branch = this.selectedBranch;
          this.$nextTick(() => {
            this.suppressBranchWatcher = false;
            this.reloadEntries();
          });
        })
        .catch((error) => {
          this.suppressBranchWatcher = false;
          console.log(error);
          this.showAlert("warning", "Error", "No se pudieron cargar las sucursales.");
        });
    },
    onBranchChange() {
      this.search.ID_Branch = this.selectedBranch;
      if (this.selectedBranch === 'all') {
        this.currentBranch = 'Todas las sucursales';
      } else {
        const selectedBranchData = this.branches.find(branch => branch.ID_Branch == this.selectedBranch);
        this.currentBranch = selectedBranchData ? selectedBranchData.BranchName : null;
      }
      this.reloadEntries();
    },
    addAccountingCodeByItem(data) {
      this.selectedExpense = data
      this.showAccountingForm = true
      this.action.ADD_ONE = true
      this.action.ADD = false
    }, 
    getAccountingEntryRowKey(row) {
      return row?.ID || row?.ExpenseInvoiceId;
    },
    hasKnownAccountingEntryState(row) {
      if (!row) {
        return false;
      }

      return Object.prototype.hasOwnProperty.call(row, 'hasAccountingEntry') || !!row.id_accounting_entry;
    },
    isAccountingEntryActionLoading(row) {
      const key = this.getAccountingEntryRowKey(row);
      return !!this.accountingEntryActionLoading[key];
    },
    setAccountingEntryActionLoading(row, value) {
      const key = this.getAccountingEntryRowKey(row);
      if (!key) {
        return;
      }

      if (value) {
        this.$set(this.accountingEntryActionLoading, key, true);
      } else {
        this.$delete(this.accountingEntryActionLoading, key);
      }
    },
    getAccountingEntryActionTitle(row) {
      if (this.isAccountingEntryActionLoading(row)) {
        return 'Cargando partida contable';
      }

      if (!this.hasKnownAccountingEntryState(row)) {
        return 'No fue posible determinar la partida contable';
      }

      return row?.id_accounting_entry ? 'Ver partida contable' : 'Crear partida contable';
    },
    handleAccountingEntryAction(row) {
      if (!this.hasKnownAccountingEntryState(row)) {
        return;
      }

      if (row.id_accounting_entry) {
        this.goToViewAccountingEntry(row);
        return;
      }

      this.openAccountingEntryAdvanced(row);
    },
    goToViewAccountingEntry(row) {
      if (!row?.id_accounting_entry) {
        this.showAlert("warning", "Advertencia", "No se encontró la partida contable asociada.");
        return;
      }

      this.$store.dispatch('addWindow', {
        name: 'Acounting',
        component: 'Acounting',
        unique: false,
        meta: {
          accountingEntryToModify: {
            id_accounting_entry: row.id_accounting_entry,
            ID_Accounting_item: row.ID_Accounting_item
          }
        }
      });
    },
    async openAccountingEntryAdvanced(row) {
      if (this.expenseType !== 'gastos' || this.isAccountingEntryActionLoading(row)) {
        return;
      }

      this.setAccountingEntryActionLoading(row, true);
      try {
        const details = await this.$API.accountingexpensesentrydetail
          .getAllAccountingExpensesEntryDetails(row.ID, { ID_Branch: row.ID_Branch });

        if (!Array.isArray(details)) {
          throw new Error('Invalid expense details response');
        }

        this.selectedExpenseForAccounting = { ...row };
        this.selectedExpenseDetails = details.map(detail => ({ ...detail }));
        this.showAccountingEntryAdvanced = true;
      } catch (error) {
        console.log(error);
        this.showAlert(
          "warning",
          "Error",
          "No fue posible cargar la información necesaria del gasto para generar la partida."
        );
      } finally {
        this.setAccountingEntryActionLoading(row, false);
      }
    },
    closeAccountingEntryAdvanced() {
      this.showAccountingEntryAdvanced = false;
      this.selectedExpenseForAccounting = null;
      this.selectedExpenseDetails = [];
    },
    updateAccountingEntryRow(result) {
      if (!this.selectedExpenseForAccounting || !this.entries) {
        return;
      }

      const rowId = this.selectedExpenseForAccounting.ID;
      const index = this.entries.findIndex(item => item.ID === rowId);
      if (index === -1) {
        return;
      }

      this.$set(this.entries, index, {
        ...this.entries[index],
        hasAccountingEntry: true,
        id_accounting_entry: result.id_accounting_entry,
        ID_Accounting_item: result.ID_Accounting_item || this.entries[index].ID_Accounting_item || null
      });
    },
    handleAccountingEntryCreated(result) {
      this.updateAccountingEntryRow(result);
      this.closeAccountingEntryAdvanced();

      if (result?.duplicate) {
        this.showAlert(
          "warning",
          "Partida existente",
          "El gasto ya poseía una partida contable asociada. La fila fue actualizada."
        );
        return;
      }

      this.showAlert(
        "success",
        "Partida contable creada",
        "La partida contable fue creada correctamente."
      );
    },
    getAllAcounts() {
      try {
        this.$API.branchaccountcatalog
          .getActiveBranchAccountCatalog()
          .then(({ data }) => {
            this.accountList = data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleAction({ action, ...data } = {}) {
      this.showAccountingForm = false
      if(action === "error") {
        this.showAlert("warning", "Advertencia", "Código contable seleccionado es invalido.")
      }
      else {
        if (this.action.ADD_ONE) {
          const expense = this.entryDetails.find(exp => exp.ID === this.selectedExpense.ID);

          if (expense) {
            expense.CatalogName = data.CatalogName
            expense.ID_AccountCatalog = data.ID_AccountCatalog
            expense.AccountCode = data.AccountCode
            console.log(expense);
            
            const result = await this.setCuentaContable(expense)
            if (result.success) {
              this.$set(expense, 'message', result.message);
            }else this.showAlert("warning", "Advertencia", "Ocurrio un error: "+ result.message);
          }else {
            this.showAlert("warning", "Advertencia", "Ocurrio un problema al agregar esta cuenta. Intente de nuevo.")
          }
        }

        if (this.action.ADD) {
          this.account = data
        }
        
      }
    },
    async setCuentaContable(itemUpdate){
      const params = {
        ID_AccountCatalog: itemUpdate.ID_AccountCatalog,
        CatalogName: itemUpdate.CatalogName,
        ID_Business: itemUpdate.ID_Business,
        ID: itemUpdate.ID,
      }
      try {
        const updateStatus = await this.$API.accountingexpensesentrydetail.updateIdAccountCatalog(params);
        return updateStatus;
      } catch (error) {
        return error;
      }
      
      
    },
    onEditorChange(e) {
      this.entry.ExpenseInvoiceComment = e.html;
      if (this.entry.ExpenseInvoiceComment != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (
        this.entry.ExpenseInvoiceComment == "" ||
        this.entry.ExpenseInvoiceComment == "<p><br></p>"
      ) {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }
    },
    formatCurrency(cellInfo, field) {
        // Cuando se usa con calculate-display-value recibe la fila y el nombre del campo
        if (field !== undefined) {
            const val = cellInfo[field];
            if (val == null) return '0.00';
            return Number(val).toFixed(2);
        }
        if (cellInfo.value == null) return '0.00'
        return cellInfo.value.toFixed(2)
    },
    formatNc(row, field) {
      let value = Number(row[field]) || 0;
      value = Math.round(value * 100) / 100;
      if (row.ExpenseInvoiceType === 'NC') {
          value = -1 * value;
      }
      return `$${value}`;
    },
    getCatalogTypedocument() {
      this.$API.catalogtypedocument
        .getCatalogTypeDocumentForProvider()
        .then(({ data }) => {
          this.catalogTypedocument = data;
        });
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options == "deleteEntry") {
        this.deleteEntry();
      }
    },
    closeAlert() {
      this.alert.show = false;
    },
    showAlert(type, title, message, action) {
      type = type == null ? "info" : type;
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.action = action ? action : (() => null);
      this.alert.show = true;
    },
    getAllEntries() {
      this.loading = true;
      this.entries = null;
      this.$API.accountingexpensesentry
        .findAllAccountingExpensesEntry({ ID_Branch: this.selectedBranch })
        .then((data) => {
          this.entries = this.normalizeEntriesWithBranchName(data);
          //console.log(this.entries);
        })
        .catch((error) => console.log("Error fetching entries:", error))
        .finally(() => { this.loading = false; });
    },
    getAllEntriesDCL() {
      // Ahora usa el endpoint específico para DCL
      this.loading = true;
      this.entries = null;
      this.$API.accountingexpensesentry
        .findAllAccountingExpensesEntryDCL({ ID_Branch: this.selectedBranch })
        .then((data) => {
          this.entries = this.normalizeEntriesWithBranchName(data);
          //console.log(this.entries);
        })
        .catch((error) => console.log("Error fetching DCL entries:", error))
        .finally(() => { this.loading = false; });
    },
    onExpenseTypeChange() {
      this.entries = null;
      // Cargar datos según el tipo seleccionado
      this.reloadEntries();
    },
    getAllEntriesWithholdingCertificates() {
      this.loading = true;
      this.entries = null;
      this.$API.accountingexpensesentry
        .findAllWithholdingCertificates({ ID_Branch: this.selectedBranch })
        .then((data) => {
          this.entries = this.normalizeEntriesWithBranchName(data);
        })
        .catch((error) => console.log('Error fetching withholding certificates:', error))
        .finally(() => { this.loading = false; });
    },
    getAllEntriesDetails() {
      this.$API.accountingexpensesentrydetail
        .getAllAccountingExpensesEntryDetails(this.entryID)
        .then((data) => {
          this.entryDetails = data;
        })
        .catch((error) => console.log(error));
    },
    handleEntry(data) {
      console.log(data)
      this.editingClassification = false;
      this.editClassificationData = {};
      this.showForm = true;
      this.entryID = data.ID;
      this.search.ID_AccountingExpensesEntry = data.ID
      if (this.expenseType !== 'comprobante_retencion') {
        this.getAllEntriesDetails();
      }
      this.entry = data;

      if(this.entry.ExpenseInvoiceComment) {
        this.showBgcolorNotes = 'tabsContent'
      }
      else{
        this.showBgcolorNotes = 'tabs'
      }
    },
    filterHandlerEntry(data) {
      this.entries = this.normalizeEntriesWithBranchName(data?.data || data);
      this.loading = false;
    },
    filterHandlerDetails(data) {
      this.entryDetails = data;
    },
    async filterDateHandler() {
      let dates = {};
      if(this.enableDates){
          dates = {
              startDate: this.startDate,
              endDate: this.endDate,
              ID_Branch: this.selectedBranch
          }
      }
      
      // Determinar qué endpoint usar según el tipo de gasto seleccionado
      let endpoint;
      if (this.expenseType === 'gastos_dcl') {
        endpoint = this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDateDCL;
      } else if (this.expenseType === 'comprobante_retencion') {
        endpoint = (params) => this.$API.accountingexpensesentry.filteredWithholdingCertificatesByDateAndSearch(params);
      } else {
        endpoint = this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDate;
      }
        
      this.loading = true;
      await endpoint(dates)
        .then((res) => {
          //console.log(res);
          this.filterHandlerEntry(res.data)
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.showAlert("warning", "Error al filtrar por fecha", "Ha ocurrido un error al filtrar por fecha.");
        })
    },
    startEditClassification() {
      this.editClassificationData = {
        ClasificationRent: this.entry.ClasificationRent,
        SectorProveedores: this.entry.SectorProveedores,
        TipoIngresoProveedores: this.entry.TipoIngresoProveedores,
        CustomCSVPeriodFlag: this.entry.CustomCSVPeriodFlag || 0,
        CustomCSVPeriodMonth: this.entry.CustomCSVPeriodMonth,
        CustomCSVPeriodYear: this.entry.CustomCSVPeriodYear,
      };
      this.editingClassification = true;
    },
    cancelEditClassification() {
      this.editingClassification = false;
      this.editClassificationData = {};
    },
    saveClassification() {
      this.$API.accountingexpensesentry
        .updateEntryClassification({
          id: this.entry.ID,
          type: this.expenseType,
          ClasificationRent: this.editClassificationData.ClasificationRent,
          SectorProveedores: this.editClassificationData.SectorProveedores,
          TipoIngresoProveedores: this.editClassificationData.TipoIngresoProveedores,
          CustomCSVPeriodFlag: this.editClassificationData.CustomCSVPeriodFlag ? 1 : 0,
          CustomCSVPeriodMonth: this.editClassificationData.CustomCSVPeriodFlag ? this.editClassificationData.CustomCSVPeriodMonth : null,
          CustomCSVPeriodYear: this.editClassificationData.CustomCSVPeriodFlag ? this.editClassificationData.CustomCSVPeriodYear : null,
        })
        .then((res) => {
          if (res.success) {
            // Actualizar entry con los nuevos valores
            this.entry.ClasificationRent = this.editClassificationData.ClasificationRent;
            this.entry.SectorProveedores = this.editClassificationData.SectorProveedores;
            this.entry.TipoIngresoProveedores = this.editClassificationData.TipoIngresoProveedores;
            this.entry.CustomCSVPeriodFlag = this.editClassificationData.CustomCSVPeriodFlag;
            this.entry.CustomCSVPeriodMonth = this.editClassificationData.CustomCSVPeriodMonth;
            this.entry.CustomCSVPeriodYear = this.editClassificationData.CustomCSVPeriodYear;
            this.editingClassification = false;
            this.showAlert('success', 'Guardado', 'Clasificación y período actualizados correctamente.');
          }
        })
        .catch(() => {
          this.showAlert('warning', 'Error', 'No se pudo guardar la clasificación.');
        });
    },
    getMonthName(value) {
      const m = this.monthList.find(m => m.value === value || m.value === parseInt(value));
      return m ? m.text : value;
    },
    getClasificationRentLabel(codigo) {
      if (!codigo) return 'N/A';
      const item = this.getCatalogMH('ComprasClasificacionRenta').find(i => i.Codigo == codigo);
      return item ? item.Valores : codigo;
    },
    getSectorLabel(codigo) {
      if (!codigo) return 'N/A';
      const item = this.sectorProveedoresList.find(i => i.Codigo == codigo);
      return item ? item.Valores : codigo;
    },
    getTipoIngresoLabel(codigo) {
      if (!codigo) return 'N/A';
      const item = this.tipoIngresoProveedoresList.find(i => i.Codigo == codigo);
      return item ? item.Valores : codigo;
    },
    confirmDeleteWithholding(data) {
      this.deleteData = data;
      this.showAlert("confirm-danger", "Eliminar", "¿Seguro que desea eliminar este comprobante de retención?", this.deleteWithholding);
    },
    getWithholdingDeleteId(data) {
      return data?.ID || data?.id || data?.ID_WithholdingCertificate || null;
    },
    deleteWithholding() {
      const id = this.getWithholdingDeleteId(this.deleteData);
      if (!id) {
        this.showAlert("warning", "Error", "No se encontró el identificador del comprobante de retención.");
        return;
      }

      this.$API.accountingexpensesentry
        .deleteWithholdingCertificate({ id })
        .then((res) => {
          if (res.success) {
            this.showForm = false;
            this.showAlert("success", "Eliminado", "El comprobante de retención ha sido eliminado correctamente.");
            this.reloadEntries();
          } else {
            this.showAlert("warning", "Error", "No se pudo eliminar el comprobante: " + (res.message || ''));
          }
        })
        .catch((error) => {
          console.log(error);
          this.showAlert("warning", "Error al eliminar", "Ha ocurrido un error al eliminar el comprobante de retención.");
        });
    },
    confirmDeleteEntry(data) {
      this.deleteData = data;
      this.showAlert("confirm-danger", "Eliminar", "¿Seguro que desea eliminar la factura de gastos seleccionada?", this.deleteEntry);
    },
    deleteEntry() {
      console.log(this.deleteData);
      
      // Determinar qué endpoint usar según el tipo de gasto
      const deleteMethod = this.expenseType === 'gastos_dcl' 
        ? this.$API.accountingexpensesentry.deleteAccountingExpensesDCL
        : this.$API.accountingexpensesentry.deleteAccountingExpenses;
      
      deleteMethod({id: this.deleteData.ID})
        .then((res) => {
          if(res.success) {
            this.showAlert("success", "Exito al eliminar registro", "La factura de gastos ha sido eliminada correctamente.");
            
            // Recargar la lista correspondiente
            this.reloadEntries();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showAlert("warning", "Error al eliminar registro", "Ha ocurrido un error al eliminar la factura de gastos.");
        });
    },
    onExporting(e) {
      printToExcel(e, "Historial de gastos");
    },
    // Método para filtrar con fechas y búsqueda de texto para gastos normales
    async filteredWithDatesAndSearch(searchParams) {
      try {
        // Si no hay filtro de texto, usar solo el filtro por fecha
        if (!searchParams.filter || searchParams.filter.trim() === '') {
          const dateParams = {
            startDate: searchParams.startDate,
            endDate: searchParams.endDate,
            ID_Branch: this.selectedBranch
          };
          const response = await this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDate(dateParams);
          return response.data;
        }
        
        // Combinar parámetros de búsqueda con fechas
        const params = {
          filter: searchParams.filter,
          startDate: searchParams.startDate,
          endDate: searchParams.endDate,
          showAllRecords: searchParams.showAllRecords,
          ID_Branch: this.selectedBranch
        };
        
        const response = await this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDateAndSearch(params);
        return response.data;
      } catch (error) {
        console.error('Error al filtrar con fechas y búsqueda:', error);
        throw error;
      }
    },
    
    // Método para filtrar comprobantes de retención con fechas y búsqueda de texto
    async filteredWithDatesAndSearchWithholding(searchParams) {
      try {
        if (!searchParams.filter || searchParams.filter.trim() === '') {
          const dateParams = {
            startDate: searchParams.startDate,
            endDate: searchParams.endDate,
            ID_Branch: this.selectedBranch
          };
          const response = await this.$API.accountingexpensesentry.filteredWithholdingCertificatesByDateAndSearch(dateParams);
          return response.data;
        }

        const params = {
          filter: searchParams.filter,
          startDate: searchParams.startDate,
          endDate: searchParams.endDate,
          showAllRecords: searchParams.showAllRecords,
          ID_Branch: this.selectedBranch
        };

        const response = await this.$API.accountingexpensesentry.filteredWithholdingCertificatesByDateAndSearch(params);
        return response.data;
      } catch (error) {
        console.error('Error al filtrar comprobantes de retención con fechas y búsqueda:', error);
        throw error;
      }
    },

    // Método para filtrar con fechas y búsqueda de texto para gastos DCL
    async filteredWithDatesAndSearchDCL(searchParams) {
      try {
        // Si no hay filtro de texto, usar solo el filtro por fecha
        if (!searchParams.filter || searchParams.filter.trim() === '') {
          const dateParams = {
            startDate: searchParams.startDate,
            endDate: searchParams.endDate,
            ID_Branch: this.selectedBranch
          };
          const response = await this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDateDCL(dateParams);
          return response.data;
        }
        
        // Combinar parámetros de búsqueda con fechas
        const params = {
          filter: searchParams.filter,
          startDate: searchParams.startDate,
          endDate: searchParams.endDate,
          showAllRecords: searchParams.showAllRecords,
          ID_Branch: this.selectedBranch
        };
        
        const response = await this.$API.accountingexpensesentry.filteredAccountingExpensesEntryByDateAndSearchDCL(params);
        return response.data;
      } catch (error) {
        console.error('Error al filtrar DCL con fechas y búsqueda:', error);
        throw error;
      }
    },
  },
 computed: {
  columnWidth() {
    return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
  },
  currentFilterEndpoint() {
    if (this.expenseType === 'comprobante_retencion') {
      if (this.enableDates && this.startDate && this.endDate) {
        return this.filteredWithDatesAndSearchWithholding;
      }
      return this.$API.accountingexpensesentry.filteredWithholdingCertificates;
    }

    // Si las fechas están habilitadas y seleccionadas, usar el endpoint de filtro por fecha y búsqueda
    if (this.enableDates && this.startDate && this.endDate) {
      return this.expenseType === 'gastos_dcl' 
        ? this.filteredWithDatesAndSearchDCL
        : this.filteredWithDatesAndSearch;
    }
    
    // Si no hay fechas habilitadas, usar el endpoint normal de búsqueda por texto
    return this.expenseType === 'gastos_dcl' 
      ? this.$API.accountingexpensesentry.filteredAccountingExpensesEntryDCL
      : this.$API.accountingexpensesentry.filteredAccountingExpensesEntry;
  },
  currentEmptyFilterMethod() {
    if (this.expenseType === 'gastos_dcl') return this.getAllEntriesDCL;
    if (this.expenseType === 'comprobante_retencion') return this.getAllEntriesWithholdingCertificates;
    return this.getAllEntries;
  },
  searchWithDates() {
    const searchObject = { ...this.search };
    searchObject.ID_Branch = this.selectedBranch;
    
    // Si las fechas están habilitadas y seleccionadas, agregarlas al objeto de búsqueda
    if (this.enableDates && this.startDate && this.endDate) {
      searchObject.startDate = this.startDate;
      searchObject.endDate = this.endDate;
    }
    
    return searchObject;
  },
  tipoIngresoProveedoresList() {
    return this.getCatalogMH('TipoIngresoProveedores');
  },
  sectorProveedoresList() {
    return this.getCatalogMH('SectorProveedores');
  },
  ...mapGetters(['getCatalogMH'])
}}
</script>

<style scoped>
.accounting-alert-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
}
.box {
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid;
  border-color: black;
}

.expense-name {
  font-weight: bold;
  font-style: oblique;
}

.container-size {
  min-width: 100% !important;
}

.bg-dark {
  background-color: #41464c;
  color: white;
}

.btn-traspaso {
  background-color: #3498db !important;
  color: white;
}

.tabsContent {
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;

  border-radius: 10px;
}

.icon-color {
  color: white !important;
}

.red-text {
  color: #cc3333 !important;
}


.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.navbar {
    display: flex;
    background: #41464c;
    color: white;
    top: 0;
    align-self: flex-start;
    z-index: 100;
    position: sticky;
    justify-content: space-around;
}

.input-group.mb-3 {
    text-align: center;
}

.input-group-prepend {
    text-align: left;
}

input.form-control {
    background: #d6eaf3;
    border: 1px solid #1976d2;
    text-align: center;
    max-width: 80px;
    height: 30px;
    border-radius: 20px;
}

.history-action-cell {
    align-items: center;
    display: flex;
    gap: 4px;
    justify-content: center;
    min-height: 26px;
}

.history-action-link {
    align-items: center;
    display: inline-flex;
    height: 26px;
    justify-content: center;
    text-decoration: none;
    width: 26px;
}

.history-action-button {
    height: 26px !important;
    width: 26px !important;
}

@media screen and (max-device-width: 1408px),
screen and (max-width: 1408px) {
    .navbar {
        margin-left: 0;
        margin-right: 0;
        height: auto;
        text-align: center;
    }

    .input-group-prepend {
        text-align: center;
    }
}

</style>
